// Layouts
import LayoutOpen from '@layouts/LayoutOpen';

export default {
    path: '/',
    component: LayoutOpen,
    children: [
        {
            path: 'review/:slug/:token?',
            name: 'review',
            component: () => import('@pages/review')
        },
        {
            path: 'kiosk/:slug',
            name: 'kiosk',
            component: () => import('@pages/kiosk')
        },
        {
            path: 'showcase/:slug',
            name: 'showcase',
            component: () => import('@pages/showcase')
        },
        {
            path: 'unsubscribe/:token',
            component: () => import('@pages/unsubscribe'),
            meta: {
                title: 'titles.unsubscribe',
            }
        },
        {
            path: 'settings/:token',
            component: () => import('@pages/unsubscribe'),
            meta: {
                title: 'titles.unsubscribe',
            }
        },
        {
            path: 'link/:token',
            component: () => import('@pages/link'),
            meta: {
                title: 'titles.redirecting',
            }
        },
    ]
};